var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slice',[_c('div',{ref:"embed",staticClass:"slice-embed",style:(_vm.styles)},[_c('prismic-embed',{ref:"obj",attrs:{"field":_vm.url || _vm.slice.primary.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }